module.exports = __webpack_public_path__ + "img/icon_recruit_welfare_08.24097671.png";